// src/shadowGrove/ui/shadowStyles.js

import { LIBERI_THEME } from "../theme/theme";
export const purpleActionBtn =
    "!inline-flex !items-center !justify-center !gap-2 !rounded-2xl !bg-[#7c3aed]/20 !border !border-[#ffd166]/30 !text-[#fff3c4] !px-4 !py-2 !text-sm !font-semibold !leading-none !w-auto !h-auto !min-h-0 !min-w-0 !transition-all !duration-200 !shadow-[0_0_14px_rgba(124,58,237,0.18)] hover:!border-[#ffd166]/75 hover:!bg-[#7c3aed]/35 hover:!shadow-[0_0_24px_rgba(255,209,102,0.22)] active:!scale-[0.98] active:!border-[#ffd166] focus:!outline-none focus:!border-[#ffd166] focus:!shadow-[0_0_22px_rgba(255,209,102,0.28)] disabled:!opacity-50 disabled:!cursor-not-allowed";

export const shadowInput =
    "mt-1 w-full !bg-black !border !border-[#ffd166]/25 !rounded-2xl !px-4 !py-2 !text-[#fff3c4] placeholder:!text-[#6c7a9c] focus:!border-[#ffd166] focus:!ring-0 !outline-none !shadow-[0_0_12px_rgba(255,209,102,0.10)]";
export const purpleActionRow =
    "flex flex-wrap items-center gap-2 mt-6";

export const shadowCalendarShell =
    "rounded-[32px] border border-[#ffd166]/40 bg-black p-6 shadow-[0_0_35px_rgba(255,209,102,0.10)] backdrop-blur-sm overflow-auto";

export const shadowCalendarToolbar =
    "rounded-[28px] border border-[#ffd166]/30 bg-black p-4 shadow-[0_0_24px_rgba(255,209,102,0.10)]";

export const shadowCalendarWeekHeader =
    "grid grid-cols-7 gap-4 text-center text-xs rounded-2xl border border-[#ffd166]/20 bg-black p-3 mb-3 min-w-[1400px]";

export const shadowCalendarGrid =
    "grid gap-4 text-center text-xs rounded-3xl border border-[#ffd166]/30 p-5 bg-black shadow-[0_0_28px_rgba(255,209,102,0.08)]";

export const shadowCalendarCell =
    "rounded-2xl border border-[#ffd166]/30 bg-black p-3 text-left shadow-[0_0_18px_rgba(255,209,102,0.08)] hover:border-[#ffd166]/70 hover:shadow-[0_0_24px_rgba(255,209,102,0.18)] transition-all duration-200";

export const shadowCalendarCellMuted =
    "rounded-2xl border border-[#ffd166]/10 bg-black/70 p-3 text-left opacity-40";

export const shadowSelectedGold =
    "!border-[#ffd166] !bg-[#ffd166]/15 !text-[#ffd166] !shadow-[0_0_22px_rgba(255,209,102,0.35)]";

export const shadowTextarea =
    "mt-2 w-full min-h-[90px] rounded-2xl border border-[#ffd166]/25 bg-black p-3 text-[#fff3c4] outline-none focus:border-[#ffd166]/70 focus:shadow-[0_0_16px_rgba(255,209,102,0.25)]";